export const handleDocumentTitleLogin = (role) => {
  if (role == "MERCHANT") {
    document.title = "No Joke Merchant";
  } else {
    document.title = "No Joke";
  }
};

export const handleDocumentTitleLogout = () => {
  document.title = "No Joke";
};
